module.exports = __webpack_public_path__ + "static/media/userAgreement.7f89fc69.svg";